// achievements
import achievementBg from './achievements/achievement_bg.png';

// branding
import logo from './globals/app_logo.svg';
import signet from './globals/signet.svg';
import activerse from './globals/activerse_logo_horizontal.svg';

// navbar
import chevron from './globals/expand_neutral_icon.svg';
import close from './globals/close_neutral_icon.svg';
import hamburger from './globals/hamburger_neutral_icon.svg';
import login from './globals/login_neutral_icon.svg';

// store logs
import appStore from './globals/app_store_badge.svg';
import googlePlay from './globals/google_play_badge.svg';

// common icons
import backIcon from './globals/back_icon.svg';
import backIconNeutral from './globals/back_icon_neutral.svg';
import infoIcon from './globals/info_icon.svg';
import settingsIcon from './globals/settings.svg';

import eye from './globals/eye_solid.svg';
import eyeSlash from './globals/eye_slash_solid.svg';

import DownArrow from './globals/expand_icon.svg?react';
import LeftArrow from './globals/back_icon_current_color.svg?react';
import RightArrow from './globals/forward_icon_current_color.svg?react';

import imagePlaceholder from './image-placeholder.jpeg';

// hydration
import hydrationSuccessIcon from './globals/done_icon.svg';
import hydrationSuccessIconLarge from './hydration/hydration_goal_reached_img.svg';

// errors
import unauthorized from './other-pages/access_unauthorized_exception_img.png';
import error404Img from './errors/404_img.svg';
import genericErrorImg from './errors/universal_error_img.svg';
import networkErrorImg from './errors/network_error_img.svg';
import noAccountErrorImg from './errors/no_account_img.svg';

// remove account
import removeAccountSuccess from './globals/notification_icon_success.svg';
import removeAccountAlert from './globals/notification_icon_danger.svg';
import removeAccountError from './globals/notification_icon_error.svg';
import doneIcon from './globals/done_icon.svg';

// thank you page
import thankYouPageBg from './thankyou/thank_you_page_main_img.png';
import thankYouPageBgMobile from './thankyou/thank_you_page_main_img_mob.png';
import thankYouPageAppPl from './thankyou/app_features_img_pl.png';
import thankYouPageLogInPl from './thankyou/log_in_img_pl.png';
import thankYouPageAppEn from './thankyou/app_features_img_en.png';
import thankYouPageLogInEn from './thankyou/log_in_img_en.png';
import confirm from './thankyou/activation_page_img.png';

// meals - shopping-list
import shoppingListIcon from './globals/groceries_icon.svg';
import noDietImg from './shopping-list/no_shopping_list_img.svg';
import handdrawnIcon from './globals/tip_box_icon.svg';
import instacartLogo from './globals/instacart.svg';
import friscoLogo from './globals/frisco.svg';

// meals - cookbook
import cookbookFavMealsIcon from './globals/cookbook_fav_meals.svg';
import cookbookFavouriteFull from './globals/favorite_icon_large_ribbon_active.png';
import cookbookFavouriteEmpty from './globals/favorite_icon_large_ribbon.png';
import favouriteFullSmall from './globals/favorite_icon_small_ribbon_active_primary_color.png';
import favouriteEmptySmall from './globals/favorite_icon_small_ribbon_primary_color.png';
import favouritesIcon from './globals/cookbook_no_fav_meals.svg';
import star from './globals/tip_box_icon.svg';

import iconChange from './globals/meal_change_ingredient_icon.svg';
import iconChangeDone from './globals/meal_change_ingredient_icon_active.svg';
import iconChangeActive from './globals/meal_changed_ingredient_icon.svg';

// meals - common
import searchIcon from './globals/search_neutral_icon.svg';
import minus from './globals/minus_item.svg';
import minusMulti from './globals/minus_set.svg';
import plus from './globals/plus_item.svg';
import plusMulti from './globals/plus_set.svg';

import ratingStarEmpty from './globals/rate_empty_small_icon_main_color.svg';
import ratingStarHalf from './globals/rate_half_large_icon_main_color.svg';
import ratingStarFull from './globals/rate_full_small_icon_main_color.svg';

import ratingStarPopupEmpty from './globals/rate_empty_large_icon_primary_color.svg';
import ratingStarPopupFull from './globals/rate_full_large_icon_primary_color.svg';

import ratingButtonEmpty from './globals/rate_filled_button_icon.svg';
import ratingButtonFull from './globals/rate_empty_button_icon.svg';

import noSearchResultsIcon from './globals/no_search_results_icon.svg';
import searchButton from './globals/search_button.svg';

// meals - dayplan
import favMealsIcon from './globals/favorite_icon.svg';
import favouriteFull from './globals/favorite_icon_large_heart_active.png';
import favouriteEmpty from './globals/favorite_icon_large_heart.png';

import gearIcon from './globals/gear.svg';
import gearIconNeutral from './globals/gear_neutral.svg';
import buttonChange from './globals/change_button_icon.svg';
import eatenButton from './globals/done_empty_button_icon.svg';
import eatenButtonFull from './globals/done_filled_button_icon.svg';
import doneKcal from './globals/meal_kcal_done_icon.svg';
import playBtn from './globals/play_button.svg';

import tomorrowAlertIcon from './globals/meal_plan_notification_icon.png';
import bulb from './globals/dietician_note_icon.svg';
import copyForTomorrow from './globals/meal_done_button_icon.svg';

import changeButton from './globals/meal_change_ingredient_icon.svg';
import iconChangeDone2 from './globals/meal_change_ingredient_icon_active.svg';
import iconChangeActive2 from './globals/meal_changed_ingredient_icon.svg';

import changeMealIcon from './globals/meal_change_meal_button.svg';
import favIcon from './globals/small_favorite_icon.svg';

import mealPlanPrice from './globals/diet_price.svg';

import weightNeeded from './meals/measurement_img.svg';
import goalLost from './meals/goal_lost_img.png';
import goalReached from './meals/goal_achieved_img.png';
import noDietPl from './meals/no_diet_img.png';
import noDietEn from './meals/no_diet_img.png';
import dietInFuture from './meals/diet_available_soon_img.svg';
import pendingPayment from './meals/payment_pending_img.svg';

// meals - fav meals
import addToMealplan from './globals/meal_add_button_icon.svg';
import favouritesIcon2 from './globals/meal_plan_favorites_no_meals_icon.png';

// flags
import flagEn from './globals/en_US.svg';
import flagSv from './globals/sv_SE.svg';
import flagPl from './globals/pl_PL.svg';
import flagCz from './globals/cs_CZ.svg';

//tracker
import trashIcon from './globals/trash_neutral_icon.svg';
import trashIcon2 from './globals/trash_icon.svg';

import dietTypeHighProtein from './tracker/settings/settings_diet_type_high_protein.jpg';
import dietTypeHighProteinEn from './tracker/settings/settings_diet_type_high_protein.jpg';

import trackerLoggedActivityThumb from './tracker/tracker_logged_activity_thumb.svg';
import trackerSyncedActivityAppleThumb from './tracker/tracker_synced_activity_apple_health_thumb.svg';
import trackerSyncedActivityGoogleThumb from './tracker/tracker_synced_activity_google_health_thumb.svg';

import trackerGoalAchievedCheck from './globals/check.svg';
import addToTrackerIcon from './globals/button_add_icon.svg';

import macroSettings from './tracker/macro_settings.svg';

import minusMacro from './globals/minus_macro.svg';
import plusMacro from './globals/plus_macro.svg';

import chartIcon from './tracker/chart_icon.svg';

import mealFromAppIcon from './globals/tracker_log_meal_from_app.svg';
import describeMealIcon from './globals/tracker_describe_meal.svg';
import scanFoodIcon from './globals/tracker_scan_food.svg';
import scanBarcodeIcon from './globals/tracker_scan_barcode.svg';
import scanBarcodePrimaryIcon from './globals/tracker_scan_barcode_primary_icon.svg';
import scanLabelIcon from './globals/tracker_scan_label.svg';
import userProductIcon from './tracker/tracker_user_product.svg';
import scanLabelTipsImg from './tracker/tracker_scan_label_tips_img.png';
import scanLabelTipsImgPl from './tracker/tracker_scan_label_tips_img_pl.png';
import scanInfoIcon from './globals/info_white_icon.svg';
import describeActivityIcon from './globals/tracker_describe_activity.svg';
import createCustomMealIcon from './globals/tracker_create_custom_meal.svg';

import editNeutralIcon from './globals/edit_neutral_icon.svg';
import addIngredientIcon from './globals/add_button_icon.svg';

import aiStarDarkIcon from './globals/ia_star_dark_icon.svg';
import aiStarLightIcon from './globals/ia_star_light_icon.svg';

import voiceLogGradient from './tracker/voice_log_gradient.png';

import microphoneOnIcon from './globals/microphone_on_icon.svg';
import microphoneOffIcon from './globals/microphone_off_icon.svg';
import microphonePrimaryIcon from './globals/microphone_primary_icon.svg';

import resetPrimaryIcon from './globals/reset_primary_icon.svg';
import editPrimaryIcon from './globals/edit_primary_icon.svg';
import editLinkIcon from './globals/edit_link_icon.svg';

import aiBadgeTiny from './tracker/ai_badge_tiny.png';

import cameraShutter from './globals/camera_shutter.svg';
import cameraIcon from './globals/camera.svg';
import closeWhiteIcon from './globals/close_white_icon.svg';
import flashOnIcon from './globals/flash_on_icon.svg';
import flashOffIcon from './globals/flash_off_icon.svg';
import infoWhiteIcon from './globals/info_white_icon.svg';
import photoGalleryIcon from './globals/photo_gallery_icon.svg';

import trackerScanFoodTipsImg from './tracker/tracker_scan_food_tips_img.png';
import trackerScanBarCodeTipsImg from './tracker/tracker_scan_barcode_tips_img.png';
import videoPoster from './tracker/video_poster.png';
import patternDot from './tracker/pattern_dot.svg';

import thumbDownActiveIcon from './globals/thumb_down_active_icon.svg';
import thumbDownDefaultIcon from './globals/thumb_down_default_icon.svg';
import thumbUpActiveIcon from './globals/thumb_up_active_icon.svg';
import thumbUpDefaultIcon from './globals/thumb_up_default_icon.svg';

import alertIcon from './globals/alert_icon.svg';

// user meals
import yourMealsAddIcon from './globals/your_meals_add_icon.svg';
import yourMealsGreyIcon from './globals/your_meals_grey_icon.svg';
import yourMealsRemoveIcon from './globals/your_meals_remove_icon.svg';
import yourMealsSavedIcon from './globals/your_meals_saved_icon.svg';
import addPlusIcon from './globals/add_plus_icon.svg';

import noMealsIcon1 from './globals/no_meal_highlight1_icon.png';
import noMealsIcon2 from './globals/no_meal_highlight2_icon.png';
import noMealsIcon3 from './globals/no_meal_highlight3_icon.png';

import trackerCookbook from './globals/tracker_cookbook.svg';
import lockIcon from './globals/lock_icon.svg';

const images = {
  achievementBg,
  logo,
  signet,
  activerse,
  backIcon,
  eye,
  eyeSlash,
  unauthorized,
  favouriteFull,
  favouriteEmpty,
  searchIcon,
  favMealsIcon,
  playBtn,
  instacartLogo,
  friscoLogo,
  star,
  hydrationSuccessIcon,
  hydrationSuccessIconLarge,
  error404Img,
  genericErrorImg,
  networkErrorImg,
  noAccountErrorImg,
  removeAccountSuccess,
  removeAccountAlert,
  removeAccountError,
  settingsIcon,
  appStore,
  googlePlay,
  imagePlaceholder,
  thankYouPageBg,
  thankYouPageBgMobile,
  thankYouPageAppPl,
  thankYouPageLogInPl,
  confirm,
  infoIcon,
  shoppingListIcon,
  doneKcal,
  changeButton,
  eatenButton,
  eatenButtonFull,
  tomorrowAlertIcon,
  noDietImg,
  handdrawnIcon,
  bulb,
  iconChangeDone2,
  iconChangeActive2,
  weightNeeded,
  goalLost,
  goalReached,
  noDietPl,
  noDietEn,
  dietInFuture,
  pendingPayment,
  changeMealIcon,
  favIcon,
  noSearchResultsIcon,
  addToMealplan,
  favouritesIcon2,
  mealPlanPrice,
  ratingStarEmpty,
  ratingStarHalf,
  ratingStarFull,
  ratingButtonEmpty,
  ratingButtonFull,
  ratingStarPopupEmpty,
  ratingStarPopupFull,
  buttonChange,
  copyForTomorrow,
  gearIcon,
  cookbookFavMealsIcon,
  cookbookFavouriteFull,
  cookbookFavouriteEmpty,
  favouriteFullSmall,
  favouriteEmptySmall,
  favouritesIcon,
  minus,
  minusMulti,
  plus,
  plusMulti,
  iconChange,
  iconChangeDone,
  iconChangeActive,
  doneIcon,
  flagEn,
  flagSv,
  flagPl,
  flagCz,
  chevron,
  close,
  hamburger,
  login,
  dietTypeHighProtein,
  dietTypeHighProteinEn,
  trashIcon,
  trashIcon2,
  trackerLoggedActivityThumb,
  trackerSyncedActivityAppleThumb,
  trackerSyncedActivityGoogleThumb,
  trackerGoalAchievedCheck,
  addToTrackerIcon,
  macroSettings,
  minusMacro,
  plusMacro,
  chartIcon,
  mealFromAppIcon,
  describeMealIcon,
  scanFoodIcon,
  scanBarcodeIcon,
  scanBarcodePrimaryIcon,
  scanLabelIcon,
  userProductIcon,
  scanLabelTipsImg,
  scanLabelTipsImgPl,
  scanInfoIcon,
  describeActivityIcon,
  thankYouPageAppEn,
  thankYouPageLogInEn,
  editNeutralIcon,
  addIngredientIcon,
  aiStarDarkIcon,
  aiStarLightIcon,
  voiceLogGradient,
  microphoneOnIcon,
  microphoneOffIcon,
  microphonePrimaryIcon,
  resetPrimaryIcon,
  editPrimaryIcon,
  aiBadgeTiny,
  cameraShutter,
  cameraIcon,
  closeWhiteIcon,
  flashOnIcon,
  flashOffIcon,
  infoWhiteIcon,
  photoGalleryIcon,
  trackerScanFoodTipsImg,
  trackerScanBarCodeTipsImg,
  videoPoster,
  patternDot,
  thumbDownActiveIcon,
  thumbDownDefaultIcon,
  thumbUpActiveIcon,
  thumbUpDefaultIcon,
  backIconNeutral,
  gearIconNeutral,
  alertIcon,
  yourMealsGreyIcon,
  addPlusIcon,
  yourMealsRemoveIcon,
  searchButton,
  yourMealsAddIcon,
  yourMealsSavedIcon,
  editLinkIcon,
  noMealsIcon1,
  noMealsIcon2,
  noMealsIcon3,
  createCustomMealIcon,
  trackerCookbook,
  lockIcon,
};

export const svgInline = {
  DownArrow,
  LeftArrow,
  RightArrow,
};

export default images;
